import { useEffect } from "react";

export const StructuredData = ({ id, data }) => {
  const serialized = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = serialized;
    document.head.appendChild(script);
    return () => script.remove();
  }, [id, serialized]);

  return null;
};
